import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const Approutes: Routes = [
  { path: 'auth', loadChildren: 'app/login/auth.module#AuthModule' },
  { path: 'in', loadChildren: 'app/in/in.module#InModule' },
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/auth/login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(Approutes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts